<template>
	<v-container class="pa-1">

    <v-snackbar v-model="alerta.activo" multi-line :vertical="true" top right :color="alerta.color" > 
      <strong> {{alerta.texto}} </strong>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
      </template>
    </v-snackbar>

    <v-card-actions>
      <div class="font-weight-black text-md-h6 text-xs-subtitle-1 "> Asignar Maquilador al pedido   </div>
      <v-spacer></v-spacer>
      <v-btn color="error" fab small elevation="1" @click="$emit('modal',false)" ><v-icon>clear</v-icon></v-btn>
    </v-card-actions>

    <!-- <v-container style="height: 300px;" v-if="Loading">
      <loading/>
    </v-container> -->

      <v-row>
        <v-col cols="12">
          <v-autocomplete
            :items="bodegas" v-model="bodega" item-text="nombre" item-value="idbodegas" label="bodegas" 
            dense filled hide-details color="primary" append-icon="people" return-object
          ></v-autocomplete>
        </v-col>
        <v-col cols="12">
          <v-autocomplete
            :items="maquiladores" v-model="maquilador" item-text="nombre" item-value="id" label="Maquiladores" 
            dense filled hide-details color="primary" append-icon="people" return-object
          ></v-autocomplete>
        </v-col>
        <v-col cols="12">
          <v-textarea
            outlined
            v-model="obs_asignacion_maquilador" 
            label="Comentarios"	
            rows="3"  
            placeholder="Escribe aquí tus comentarios..." >
          ></v-textarea>
        </v-col>
      </v-row>

      <div class="mt-6"></div>

      <v-footer absolute >
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="modalValidarAsignacion = true"> Asignar pedido </v-btn>
      </v-footer>
      
    
    <v-dialog v-model="modalValidarAsignacion" persistent width="500">
        <v-card>
          <v-card-title class="subtitle-1 font-weight-black " style="word-break:normal;">¿ESTÁS SEGURO DE QUERER ASIGNAR EL PEDIDO ? </v-card-title>
          <v-divider class="my-0 py-3" ></v-divider>
          <v-card-subtitle align="center" class="red--text font-weight-bold "> UNA VEZ ATENDIDA NO PODRÁ EDITARSE </v-card-subtitle>
          <v-divider class="my-0 py-2 " ></v-divider>
          <v-card-actions>
            <v-btn color="error" dark @click="modalValidarAsignacion=false" >  NO, Cancelar </v-btn>
            <v-spacer/>
            <v-btn color="primary" text @click="asignarPedidoAMaquilador()" >  SÍ, Asignar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

		<overlay v-if="overlay"/>
  </v-container>
</template>

<script>
  import  metodos from '@/mixins/metodos.js';
	import {mapGetters, mapActions} from 'vuex'
  // import loading from '@/components/loading.vue'
  import overlay from '@/components/overlay.vue'

  export default {
    mixins:[metodos],
	  components: {
			// loading,
      overlay
		},
		props:[
			'parametros',
	  ],

    data(){
      return{
        // Loading: false,

        ObjectDefault:{},
        alerta: { activo: false, texto:'', color:'error' },
        overlay: false,

        bodegas:[],
        bodega:{idbodegas:null, nombre:''},
        maquiladores: [],
        maquilador:{ id: null, nombre:'' },
        obs_asignacion_maquilador: '',

        modalValidarAsignacion: false, 

      }
    },

    created(){
				this.initialize();
		},

    watch:{
			parametros(){
				this.initialize();
			},
    },
			
		computed:{
			// IMPORTANDO USO DE VUEX - CLIENTES (GETTERS)
      ...mapGetters('Login',['getusuarioFetish']),
		},

    watch: {
      async bodega(){
        let idBodegas = this.bodega.idbodegas;
        let idNiveles = 3
        this.maquiladores = await this.consultar_tipo_usuario(idBodegas, idNiveles);
      }
    },

    methods:{
      
      async initialize(){

        // this.Loading = true;
        // this.envio       = this.parametros.direcciones[0];
        // this.facturacion = this.parametros.facturacion[0];
        // this.productos   = this.parametros.movim;
        this.bodegas = await this.consultar_bodegas();
        setTimeout(()=> {this.Loading = false }, 500); 
        
      },

      asignarPedidoAMaquilador() {
        this.overlay = true;
        this.modalValidarAsignacion = false;
        
        const payload = {
          idpedidos: this.parametros.iddocum,
          idbodegas: this.bodega.idbodegas,
          idmaquilador: this.maquilador.id,
          obs_asignacion_maquilador: this.obs_asignacion_maquilador
        }

        this.$http.post('asignar.maquilador.pedido', payload).then( response =>{
          var that = this;
          this.alerta = { activo: true, color:'success', texto: "Asignacion Procesada Correctamente" };
          setTimeout(() => { that.$emit('modal') }, 1000);
          this.finalizarProceso()
        }).catch( error =>{
          console.log('error', error);
          this.alerta = { activo: true, color:'error', texto: error.message };
        }).finally(()=>{ 
          this.overlay = false
        })

      }

    } 

  }
</script>